export const isJwInlandApp = process.env.APP_TYPE_ENV === "jw-inland";
export const isJwIntlApp = process.env.APP_TYPE_ENV === "jw-intl";
export const isPersonalApp = process.env.APP_TYPE_ENV === "personal";
export const isJwApp = isJwInlandApp || isJwIntlApp
